import constants from '../constants';

const initialState = {
  data: [],
  config: null,
  campaignName: null,
  isLoading: false,
  isActive: false,
  error: null,
};

export default function campaignReducer(state = initialState, action) {
  switch (action.type) {
    case constants.CAMPAIGN_GET:
      return {
        ...state,
        config: action.data.config,
        campaignName: action.data.campaignName,
        isActive: action.data.isActive,
        error: null,
      };

    case constants.CAMPAIGN_GET_OFFERS:
      return {
        ...state,
        data: action.data.data,
        isLoading: action.data.isLoading,
        campaignName: action.data.campaignName,
        error: null,
      };

    case constants.CAMPAIGN_CLEAR:
      return initialState;

    case constants.CAMPAIGN_CLIP_OFFER:
      const { data: offer } = action;
      const offers = state.data.map((currentOffer) =>
        currentOffer.mdid === offer.mdid ? { ...currentOffer, clipped: true } : currentOffer
      );
      return { ...state, data: offers };

    case constants.CAMPAIGN_SET_ACTIVE:
      return {
        ...state,
        campaignName: action.data,
      };

    case constants.CAMPAIGN_LOADER:
      return { ...state, isLoading: action.isLoading };

    case constants.CAMPAIGN_ERROR:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    default:
      return state;
  }
}
